export default __webpack_public_path__ + "static/media/Aimee.042d647d.jpeg";